import { Pipe, PipeTransform } from '@angular/core';

import { ÉTAT_GROUPE, étatGroupeOrdre } from '../enum/état-groupe.enum';
import { Groupe } from '../models/groupe.model';

@Pipe({
  name: 'getEtatEtape',
  pure: true,
})
export class GetEtatEtapePipe implements PipeTransform {
  transform(groupes?: Groupe[]): ÉTAT_GROUPE {
    if (!groupes || !groupes.length) return ÉTAT_GROUPE.A_FAIRE;

    return groupes
      .map((x) => x.etat)
      .reduce((min, current) => (étatGroupeOrdre[current] < étatGroupeOrdre[min] ? current : min));
  }
}
